// src/data/CaseStudiesData.js
export const CASE_STUDIES = [
  {
  //   id: "skyline-residence",
  //   slug: "/case-studies/skyline-residence",
  //   title: "Skyline Residence — Pre-Sale Launch",
  //   cover: "/images/case/skyline/cover.jpg",
  //   hero: "/images/case/skyline/hero.jpg",
  //   story: `A modern penthouse launch needed media that sold the view and flow
  //           of the space. We built an immersive package that let buyers “feel”
  //           the property before visiting.`,
  //   goals: [
  //     "Pre-sell units prior to model suite completion",
  //     "Demonstrate natural light and flow to out-of-town buyers",
  //     "Drive qualified booking requests for private showings"
  //   ],
  //   results: [
  //     "42% increase in inquiry-to-visit conversion in 30 days",
  //     "Booked out all weekend showings within 10 days",
  //     "Marketing cost per qualified lead down by 27%"
  //   ],
  //   tech: ["360° Virtual Tour (krpano)", "Drone (4K HDR)", "Photography", "Promo Video", "Web Landing (React + Netlify)"],
  //   media: [
  //     { type: "image", src: "/images/case/skyline/1.jpg" },
  //     { type: "video", src: "/videos/case/skyline-reel.mp4" },
  //     { type: "image", src: "/images/case/skyline/2.jpg" }
  //   ],
  // },
  // {
  //   id: "harbor-lofts",
  //   slug: "/case-studies/harbor-lofts",
  //   title: "Harbor Lofts — Airbnb Occupancy Lift",
  //   cover: "/images/case/harbor/cover.jpg",
  //   hero: "/images/case/harbor/hero.jpg",
  //   story: `A boutique set of Airbnb units needed consistent bookings in shoulder
  //           months. We focused on trust-building visuals and an optimized gallery order.`,
  //   goals: [
  //     "Increase shoulder-season occupancy",
  //     "Reduce booking hesitation with transparent visuals",
  //     "Improve listing CTR and save-to-favorite rate"
  //   ],
  //   results: [
  //     "Occupancy up 19% in 8 weeks",
  //     "Listing CTR +23% after media refresh",
  //     "Fewer pre-booking questions from guests"
  //   ],
  //   tech: ["Photography", "Video Walkthrough", "Thumbnail A/B test", "Listing Optimization"],
  //   media: [
  //     { type: "image", src: "/images/case/harbor/1.jpg" },
  //     { type: "image", src: "/images/case/harbor/2.jpg" },
  //     { type: "video", src: "/videos/case/harbor-short.mp4" }
  //   ],
  // },
  // {
  //   id: "atelier-block",
  //   slug: "/case-studies/atelier-block",
  //   title: "Atelier Block — Developer Showcase",
  //   cover: "/images/case/atelier/cover.jpg",
  //   hero: "/images/case/atelier/hero.jpg",
  //   story: `For a multi-unit development, we created a centralized media hub that
  //           made sales reps self-sufficient and kept messaging consistent across channels.`,
  //   goals: [
  //     "Unify assets for agents and partners",
  //     "Create fast-loading media hub for mobile",
  //     "Highlight finishes and amenity value"
  //   ],
  //   results: [
  //     "Agent time-to-asset down from days to minutes",
  //     "Consistent brand visuals across all channels",
  //     "Faster client follow-ups with ready-to-share links"
  //   ],
  //   tech: ["Photo", "Drone", "360° hotspots", "Mini-site (React)", "Netlify Forms"],
  //   media: [
  //     { type: "image", src: "/images/case/atelier/1.jpg" },
  //     { type: "image", src: "/images/case/atelier/2.jpg" },
  //     { type: "image", src: "/images/case/atelier/3.jpg" }
  //   ],
  }
];
